import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { DefMembersipTypes } from "../actions/defMembership-actions";

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  defMembership: null,
  membershipAccounts: [],
  error: null,
  fetching: false,
  updating: false,
  switching: false,
});

/* ------------- Reducers ------------- */

export const request = (state) => {
  return { ...state, fetching: true, switching: false, defMembership: null, error: null };
};

export const success = (state, data) => {
  const { defMembership, membershipAccounts } = data;
  return {
    ...state,
    fetching: false,
    switching: false,
    error: null,
    defMembership,
    membershipAccounts: membershipAccounts || [],
  };
};

export const failure = (state, { error }) => {
  return {
    ...state,
    fetching: false,
    updating: false,
    switching: false,
    defMembership: null,
    membershipAccounts: [],
    error,
  };
};

export const switchRequest = (state) => {
  return { ...state, switching: true, error: null };
};

export const switchFailure = (state, { error }) => {
  return { ...state, switching: false, error };
};

export const defMembershipResetSuccess = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {
  [DefMembersipTypes.DEF_MEMBERSHIP_REQUEST]: request,
  [DefMembersipTypes.DEF_MEMBERSHIP_SUCCESS]: success,
  [DefMembersipTypes.DEF_MEMBERSHIP_FAILURE]: failure,
  [DefMembersipTypes.DEF_MEMBERSHIP_RESET_SUCCESS]: defMembershipResetSuccess,
  [DefMembersipTypes.SWITCH_MEMBERSHIP_REQUEST]: switchRequest,
  [DefMembersipTypes.SWITCH_MEMBERSHIP_SUCCESS]: success,
  [DefMembersipTypes.SWITCH_MEMBERSHIP_FAILURE]: switchFailure,
  [DefMembersipTypes.SET_DEFAULT_MEMBERSHIP_REQUEST]: switchRequest,
  [DefMembersipTypes.SET_DEFAULT_MEMBERSHIP_SUCCESS]: success,
  [DefMembersipTypes.SET_DEFAULT_MEMBERSHIP_FAILURE]: switchFailure,
});
